<template>
  <section class="checkout-area pb-85">
    <div class="container">
      <div v-if="cartStore.cart_products.length === 0" class="text-center pt-50">
        <h3 class="py-2">No items found in cart to checkout</h3>
        <router-link href="/shop" class="cart-btn">Return to shop</router-link>
      </div>
      <form v-else @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-lg-6">
            <div class="checkbox-form">
              <h3>Billing Details</h3>

              <div class="row">
                <!-- Radio Button for Existing Addresses -->
                <div class="col-md-12">
                  <div class="checkout-form-list">
                    <label>Select Billing Address</label>
                    <div v-for="address in addresses" :key="address.id" class="address-selection">
                      <input type="radio" :id="'address-' + address.id" name="billingAddress" :value="address.id"
                        v-model="selectedAddressId" @change="fillAddressForm(address)" />
                      <label :for="'address-' + address.id">
                        {{ address.name }} - {{ address.address }}, {{ address.city }}, {{ address.zip_code }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Billing Form -->
              <div class="col-md-12">
                <h4>Or Fill Your Billing Details</h4>
              </div>
              <p></p>
              <div class="row">
                <div class="col-md-12">
                  <div class="country-select">
                    <label>Country <span class="required">*</span></label>
                    <select v-model="formData.country">
                      <option value="">Select a country</option>
                      <option v-for="country in countries" :key="country.id" :value="country.id">
                        {{ country.name }}
                      </option>
                    </select>
                    <div v-if="errors.country" class="error-msg">{{ errors.country }}</div>
                  </div>
                </div>

                <!-- Name -->
                <div class="col-md-12">
                  <div class="checkout-form-list">
                    <label>Name <span class="required">*</span></label>
                    <input v-model="formData.name" type="text" placeholder="Name" />
                    <div v-if="errors.name" class="error-msg">{{ errors.name }}</div>
                  </div>
                </div>


                <!-- Company Name -->
                <div class="col-md-12">
                  <div class="checkout-form-list">
                    <label>Company Name </label>
                    <input v-model="formData.company_name" type="text" placeholder="Company Name" />
                    <div v-if="errors.company_name" class="error-msg">{{ errors.company_name }}</div>
                  </div>
                </div>



                <!-- Address -->
                <div class="col-md-12">
                  <div class="checkout-form-list">
                    <label>Address <span class="required">*</span></label>
                    <input v-model="formData.address" type="text" placeholder="Street address" />
                    <div v-if="errors.address" class="error-msg">{{ errors.address }}</div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="checkout-form-list"><input v-model="formData.address_2" type="text"
                      placeholder="Apartment, suite, unit etc. (optional)"></div>
                </div>

                <!-- City -->
                <div class="col-md-6">
                  <div class="checkout-form-list">
                    <label>City <span class="required">*</span></label>
                    <input v-model="formData.city" type="text" placeholder="Town / City" />
                    <div v-if="errors.city" class="error-msg">{{ errors.city }}</div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="checkout-form-list"><label>Postcode / Zip <span class="required">*</span></label><input
                      name="zip_code" id="zip_code" v-model="formData.zip_code" type="text"
                      placeholder="Postcode / Zip">
                    <div v-if="errors.zip_code" class="error-msg">{{ errors.zip_code }}</div>
                  </div>
                </div>

                <!-- Email -->
                <div class="col-md-6">
                  <div class="checkout-form-list">
                    <label>Email Address <span class="required">*</span></label>
                    <input v-model="formData.email" type="email" placeholder="Email Address" />
                    <div v-if="errors.email" class="error-msg">{{ errors.email }}</div>
                  </div>
                </div>

                <!-- Phone -->
                <div class="col-md-6">
                  <div class="checkout-form-list">
                    <label>Phone <span class="required">*</span></label>
                    <input v-model="formData.phone" type="text" placeholder="Phone" />
                    <div v-if="errors.phone" class="error-msg">{{ errors.phone }}</div>
                  </div>
                </div>
              </div>
              <div class="different-address">
                <div class="order-notes">
                  <div class="checkout-form-list"><label>Order Notes</label><textarea v-model="formData.order_note"
                      name="orderNote" id="orderNote" cols="30" rows="10"
                      placeholder="Notes about your order, e.g. special notes for delivery."></textarea></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Order Summary -->
          <div class="col-lg-6">
            <div class="your-order mb-30">
              <h3>Your order</h3>
              <div class="your-order-table table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th style="width: 80%;" class="product-name">Product</th>
                      <th class="product-total" style="text-align: right;">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in cartStore.cart_products" :key="item.id" class="cart_item">
                      <td class="product-name">
                        {{ item.title }}
                        <strong class="product-quantity">
                          × {{ item.orderQuantity }}
                        </strong>
                      </td>
                      <td style="text-align: right;" class="product-total">
                        <span class="amount" v-if="typeof item.price === 'number'">
                          {{ item.price.toFixed(2) }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="cart-subtotal">
                      <th>Cart Subtotal</th>
                      <td style="text-align: right;">
                        <span class="amount">
                          {{ cartStore.totalPriceQuantity.total.toFixed(2) }}
                        </span>
                      </td>
                    </tr>
                    <tr class="order-total">
                      <th>Order Total</th>
                      <td style="text-align: right;">
                        <strong>
                          <span class="amount">
                            {{ (cartStore.totalPriceQuantity.total + shipCost).toFixed(2) }}
                          </span>
                        </strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <!-- Place Order Button -->
              <div class="order-button-payment mt-20">
                <button type="submit" class="tp-btn-h1">Place order</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>


<script>
import { useCartStore } from "@/stores/useCartStore"
import { toast } from "vue3-toastify"

export default {
  name: "CheckoutArea",
  data() {
    return {
      cartStore: useCartStore(),
      shipCost: 0,
      user: JSON.parse(localStorage.getItem('user')) || { name: 'Guest', email: '' },
      formData: {
        name: "",
        country: "",
        address: "",
        address_2: "",
        city: "",
        email: "",
        phone: "",
        zip_code: "",
        company_name: "",
        order_note: ""
      },
      selectedAddressId: null, // Track selected address ID
      countries: [],
      addresses: [],
      errors: {},
    }
  },
  methods: {
    async loadCountries() {
      try {
        const response = await this.$axios.get("/countries")
        this.countries = response.data
      } catch (error) {
        console.error("Error loading countries:", error)
        toast.error("Failed to load countries. Please try again.")
      }
    },

    async loadAddress() {
      try {
        const response = await this.$axios.get("/get-user-address/" + this.user.id)
        this.addresses = response.data
      } catch (error) {
        console.error("Error loading address:", error)
        toast.error("Failed to load addressh. Please try again.")
      }
    },

    fillAddressForm(address) {
      this.formData.name = address.name;
      this.formData.country = address.country_id;
      this.formData.address = address.address;
      this.formData.address_2 = address.address_2;
      this.formData.city = address.city;
      this.formData.zip_code = address.zip_code;
      this.formData.phone = address.phone;
    },

    validateForm() {
      this.errors = {}

      if (this.selectedAddressId) {
        return true
      }

      if (!this.formData.name) {
        this.errors.name = "Name is required."
      }

      if (!this.formData.country) {
        this.errors.country = "Country is required."
      }
      if (!this.formData.address) {
        this.errors.address = "Address is required."
      }
      if (!this.formData.city) {
        this.errors.city = "City is required."
      }
      if (!this.formData.email || !/\S+@\S+\.\S+/.test(this.formData.email)) {
        this.errors.email = "A valid Email Address is required."
      }
      if (!this.formData.phone) {
        this.errors.phone = "Phone is required."
      }
      

      return Object.keys(this.errors).length === 0
    },

    async onSubmit() {
      if (!this.validateForm()) {
        return
      }

       try {
      // Construct payload
      const payload = {
        cart: this.cartStore.cart_products.map((item) => ({
          id: item.id,
          orderQuantity: item.orderQuantity,
          price: item.price,
        })),
        user_id: this.user.id,
        total: this.cartStore.totalPriceQuantity.total + this.shipCost,
        order_note: this.formData.order_note,
      };

      // Include selected address or new address
      if (this.selectedAddressId) {
        payload.address_id = this.selectedAddressId; // Send selected address ID
      } else {
        payload.new_address = { ...this.formData }; // Send new address details
      }

      // Send order request
      // eslint-disable-next-line no-unused-vars
      const response = await this.$axios.post("/orders", payload);

      // Handle success
      toast.success("Order placed successfully");
      this.cartStore.clear_cart();
      window.location.href = "/my-account";
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Failed to place the order. Please try again.");
    }
    },
  },
  async mounted() {
    await this.loadCountries()
    await this.loadAddress()
    this.formData.name = this.user.name
    this.formData.email = this.user.email
    this.formData.user_id = this.user.id
    console.log(this.user.id)
  },

}
</script>
<style scoped>
.error-msg {
  color: red;
  font-size: 0.875rem;
  /* Adjust font size */
  margin-top: 5px;
}
</style>
